import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Building, Map } from 'lucide-react';
import axios from 'axios';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState({ submitted: false, error: false });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, formData);
      setStatus({ submitted: true, error: false });
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (err) {
      setStatus({ submitted: false, error: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-32 pb-24 min-h-screen bg-slate-50">
      <div className="container mx-auto px-6 max-w-7xl">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-4">Bize Ulaşın</h1>
            <p className="text-lg text-slate-600 font-medium max-w-2xl mx-auto">Projelerimiz ve kooperatifimiz hakkında detaylı bilgi almak için iletişim kanallarımızdan bize ulaşabilirsiniz.</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
            {/* Adres Kartları */}
            <div className="lg:col-span-4 space-y-6">
              
              <div className="bg-white p-8 rounded-3xl shadow-lg shadow-slate-200/50 border border-slate-100 flex flex-col gap-4 relative overflow-hidden group">
                <div className="absolute top-0 right-0 w-24 h-24 bg-blue-50 rounded-bl-full -z-10 group-hover:scale-110 transition-transform"></div>
                <div className="w-14 h-14 bg-blue-600 text-white rounded-2xl flex items-center justify-center shrink-0 shadow-md">
                  <Building size={28} />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 mb-2 text-xl">Merkez Ofis</h3>
                  <p className="text-slate-600 font-medium leading-relaxed">
                    Osb. Mh. Dolapdere Sanayi Sitesi<br />
                    Dolapdere İş Merkezi No: 27 - 4<br />
                    İkitelli / Başakşehir / İstanbul
                  </p>
                </div>
              </div>

              <div className="bg-white p-8 rounded-3xl shadow-lg shadow-slate-200/50 border border-slate-100 flex flex-col gap-4 relative overflow-hidden group">
                <div className="absolute top-0 right-0 w-24 h-24 bg-emerald-50 rounded-bl-full -z-10 group-hover:scale-110 transition-transform"></div>
                <div className="w-14 h-14 bg-emerald-500 text-white rounded-2xl flex items-center justify-center shrink-0 shadow-md">
                  <Map size={28} />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 mb-2 text-xl">Şantiye Adresi</h3>
                  <p className="text-slate-600 font-medium leading-relaxed">
                    Enlem Soğuk Hava Depolama<br />
                    Lojistik ve Gıda Sanayi A.Ş.<br />
                    Gümüşyaka, İstanbul Çorlu Yolu<br />
                    34580 Silivri / İstanbul
                  </p>
                </div>
              </div>

              <div className="bg-slate-900 text-white p-8 rounded-3xl shadow-lg flex flex-col gap-6">
                <a href="tel:+902128778918" className="flex items-center gap-4 group/contact hover:opacity-90 transition-opacity">
                  <div className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center shrink-0 group-hover/contact:bg-white/20 transition-colors">
                    <Phone size={24} className="text-blue-400" />
                  </div>
                  <div>
                    <h3 className="font-medium text-slate-400 mb-1 text-sm">Telefon</h3>
                    <p className="text-white font-bold text-lg group-hover/contact:text-blue-300 transition-colors">+90 212 877 89 18</p>
                  </div>
                </a>
                <div className="w-full h-px bg-white/10"></div>
                <a href="mailto:info@isilkoop.com" className="flex items-center gap-4 group/contact hover:opacity-90 transition-opacity">
                  <div className="w-12 h-12 bg-white/10 rounded-xl flex items-center justify-center shrink-0 group-hover/contact:bg-white/20 transition-colors">
                    <Mail size={24} className="text-blue-400" />
                  </div>
                  <div>
                    <h3 className="font-medium text-slate-400 mb-1 text-sm">E-Posta</h3>
                    <p className="text-white font-bold text-lg group-hover/contact:text-blue-300 transition-colors">info@isilkoop.com</p>
                  </div>
                </a>
              </div>

            </div>

            {/* İletişim Formu */}
            <div className="lg:col-span-8 bg-white p-8 md:p-12 rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100">
              <h3 className="text-3xl font-extrabold text-slate-900 mb-8">İletişim Formu</h3>
              {status.submitted ? (
                <div className="bg-green-50 text-green-700 p-8 rounded-2xl text-center font-bold text-lg border border-green-200 flex flex-col items-center justify-center h-full gap-4">
                  <div className="w-20 h-20 bg-green-500 text-white rounded-full flex items-center justify-center mb-2 shadow-lg shadow-green-500/30">
                    <MapPin size={40} />
                  </div>
                  Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  {status.error && <div className="text-red-500 text-sm font-bold bg-red-50 p-4 rounded-xl">Bir hata oluştu, lütfen tekrar deneyin.</div>}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="space-y-2">
                      <label className="text-sm font-bold text-slate-700">Adınız Soyadınız</label>
                      <input required type="text" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} className="w-full px-5 py-4 rounded-xl border-2 border-slate-100 focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 bg-slate-50 focus:bg-white font-medium transition-all" placeholder="John Doe" />
                    </div>
                    <div className="space-y-2">
                      <label className="text-sm font-bold text-slate-700">E-Posta Adresiniz</label>
                      <input required type="email" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} className="w-full px-5 py-4 rounded-xl border-2 border-slate-100 focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 bg-slate-50 focus:bg-white font-medium transition-all" placeholder="ornek@mail.com" />
                    </div>
                  </div>
                  <div className="space-y-2">
                    <label className="text-sm font-bold text-slate-700">Konu</label>
                    <input required type="text" value={formData.subject} onChange={e => setFormData({...formData, subject: e.target.value})} className="w-full px-5 py-4 rounded-xl border-2 border-slate-100 focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 bg-slate-50 focus:bg-white font-medium transition-all" placeholder="Mesajınızın konusu" />
                  </div>
                  <div className="space-y-2">
                    <label className="text-sm font-bold text-slate-700">Mesajınız</label>
                    <textarea required rows={5} value={formData.message} onChange={e => setFormData({...formData, message: e.target.value})} className="w-full px-5 py-4 rounded-xl border-2 border-slate-100 focus:outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-500/10 bg-slate-50 focus:bg-white font-medium transition-all resize-none" placeholder="Mesajınızı buraya yazınız..."></textarea>
                  </div>
                  <button type="submit" disabled={loading} className="px-10 py-5 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-bold text-lg transition-all w-full shadow-xl shadow-blue-600/20 disabled:opacity-50 hover:-translate-y-1">
                    {loading ? 'Gönderiliyor...' : 'Mesaj Gönder'}
                  </button>
                </form>
              )}
            </div>
          </div>

          {/* Harita Bölümü */}
          <div className="w-full bg-white p-4 rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100">
            <h3 className="text-2xl font-bold text-slate-900 mb-6 px-4 pt-4">Konumlarımız</h3>
            <div className="w-full h-[500px] rounded-2xl overflow-hidden relative bg-slate-100">
              <iframe
                src="https://maps.google.com/maps?q=Enlem+So%C4%9Fuk+Hava+Depolama+Lojistik+ve+G%C4%B1da+Sanayi+A.%C5%9E.,+G%C3%BCm%C3%BC%C5%9Fyaka,+%C4%B0stanbul+%C3%87orlu+Yolu,+34580+Silivri%2F%C4%B0stanbul&t=&z=15&ie=UTF8&iwloc=B&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Şantiye - Enlem Soğuk Hava Depolama, Gümüşyaka, Silivri"
              ></iframe>
            </div>
          </div>

        </motion.div>
      </div>
    </div>
  );
};

export default Contact;
